module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['rt-divider', ("rt-divider-" + _vm.direction), {
      'rt-divider-dashed': _vm.dashed
    }]
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268e2e03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/divider/rtDivider.vue
// module id = 2092
// module chunks = 137